'use strict';

import { getVueTemplate } from '../../../../_imports/utils/utils.common';
import ResourceCardCommon from '../_imports/shared/resource-card.common';
import { sanitizeHtml } from '../../../../_imports/shared/vue-utils.common';

const resourceCardMedium = {
    template: getVueTemplate('resource-card-medium'),
    mixins: [ResourceCardCommon, sanitizeHtml],
    computed: {
        strippedResourceTitle() {
            return this.sanitizeHtml(this.resource.title);
        },
        resourceCardDSTheme() {
            return this.styling?.resourceCardDSTheme || 'light';
        },
        resourceCardDSBackgroundShade() {
            return this.styling?.resourceCardDSBackgroundShade || 'default';
        },
        isSimpleVideoCard() {
            return this.styling?.resourcePresentation === 'medium-cards-simple-video';
        },
        hasDuration() {
            return this.resource?.video?.duration;
        },
        duration() {
            return Math.ceil(this.resource?.video?.duration / 60) + ' MIN';
        },
        displayThumbnails() {
            return this.styling.displayThumbnails && this.resource.thumbnail && this.resource.thumbnail.src;
        },
        popUpOnClick() {
            return this.popUpBehaviourActivated && this.resource.video?.videoCode;
        }
    },
    methods: {
        openPopUpModal() {
            this.$emit('openPopUpModal', this.resource.itemID);
        }
    }
};

export default resourceCardMedium;